'use client';

import { RepeatWrapping } from 'three';
import { useTexture } from '@react-three/drei';
import { useFrame, invalidate } from '@react-three/fiber';
import { useRef } from 'react';

import './MeshBannerMaterial'; // Import the extended material

function Banner({ radius = 1.6, ...props }) {
    const ref = useRef(null);

    const texture = useTexture('/2banner.jpg');
    texture.wrapS = texture.wrapT = RepeatWrapping;

    useFrame((state, delta) => {
        if (!ref.current) return;
        const material = ref.current.material;
        if (material.map) {
            material.map.offset.x += delta / 30;
            invalidate();
        }
    });

    return (
        <mesh ref={ref} {...props}>
                 </mesh>
    );
}

export default Banner;
